import { Typography } from '@euler/app/components/typography';
import { useOrderDetailContext } from '@euler/app/flows/order/components/OrderDetailProvider';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrderReturnType } from '@euler/model/enum';
import { memo } from 'react';
import { View } from 'react-native';
import { OrderInfoSection as Section } from './Section';

export const CustomerSignSection = memo(() => {
  const { rpx } = useResponsiveContext();

  const { signImgUrl, returnType } = useOrderDetailContext();

  return (
    <Section title="客户签字">
      <View
        css={`
          padding: ${rpx(15)}px;
        `}
      >
        {signImgUrl ? (
          <Img
            uri={signImgUrl}
            resizeMode="contain"
            css={`
              aspect-ratio: ${5 / 3};
            `}
          />
        ) : (
          <Typography.Label color="#777">
            {returnType === OrderReturnType.Pick ||
            returnType === OrderReturnType.Deliver
              ? '客户未在厂'
              : '尚未签名'}
          </Typography.Label>
        )}
      </View>
    </Section>
  );
});
